import script from "./WorkCase.vue?vue&type=script&setup=true&name=WorkCase&lang=js"
export * from "./WorkCase.vue?vue&type=script&setup=true&name=WorkCase&lang=js"

import "./WorkCase.vue?vue&type=style&index=0&id=2ee5eace&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ee5eace"]])

export default __exports__